import clsx from 'clsx'
import React, { FC } from 'react'
import { IoCloseOutline } from 'react-icons/io5'
import s from './Close.module.scss'

export type CloseProps = {
  className?: string
} & React.ComponentProps<typeof IoCloseOutline>
const Close: FC<CloseProps> = ({ className, ...props }) => {
  return <IoCloseOutline className={clsx(s.root, className)} {...props} />
}

export default Close
